<script language="ts">
    import { Link } from "../routing/index";

    const landscape_images = [
        {
            url: "/static/front_images/fast1_{size}.jpg",
            css: "color-scheme-blue shadow-down-right-strong",
        },
        {
            url: "/static/front_images/fast2_{size}.jpg",
            css: "color-scheme-red shadow-down-right",
        },
        {
            url: "/static/front_images/girl_with_skiis_{size}.jpg",
            css: "color-scheme-blue shadow-down-right-strong",
        },
        {
            url: "/static/front_images/looking_{size}.jpg",
            css: "color-scheme-red2 shadow-right",
        },
        {
            url: "/static/front_images/snowboard1_{size}.jpg",
            css: "color-scheme-white shadow-down-right",
        },
        {
            url: "/static/front_images/angels_{size}.jpg",
            css: "color-scheme-white shadow-down-right",
        },
    ];

    const portrait_images = [
        {
            url: "/static/front_images/girl_with_skiis_portrait_{size}.jpg",
            css: "portrait color-scheme-blue shadow-down-right-strong",
        },
        {
            url: "/static/front_images/looking_portrait_{size}.jpg",
            css: "portrait color-scheme-red2 shadow-right",
        },
    ];

    const images = window.innerHeight > window.innerWidth ? portrait_images : landscape_images;

    const image = images[Math.min(Math.floor(Math.random() * images.length), images.length - 1)];

    if (window.innerWidth > 1000) {
        image.url = image.url.replace("{size}", "large");
    } else {
        image.url = image.url.replace("{size}", "small");
    }

    const logStart = () => {
        if (plausible) {
            plausible("Start quiz");
        }
    };
</script>

<!-- svelte-ignore a11y-missing-attribute -->
<main class="landing-page {image.css}" style="background-image: url({image.url});">
    <h1>Fjälltoppen</h1>
    <h2>Vi vet vart du ska åka på din nästa skidresa</h2>
    <Link to="/start" on:click={() => logStart()}>Hitta bästa skidorten för dig</Link>
</main>

<svelte:head>
    <title>Fjälltoppen - Jämför svenska skidorter</title>
    <meta
        name="description"
        content="Hitta bästa skidorten för just dig! Här kan du enkelt jämföra Sveriges alla skidbackar utifrån restid, familjevänlighet, offpistmöjliheter..."
    />
</svelte:head>

<style>
    main {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;
        flex-grow: 1;
    }

    .portrait {
        background-position: top;
    }

    h1 {
        font-size: 100px;
        color: white;
        margin-bottom: 10px;
        text-shadow: 0.8px 0.8px 1.2px rgba(0, 0, 0, 0.046), 1.7px 1.7px 2.9px rgba(0, 0, 0, 0.066),
            2.9px 2.9px 5.3px rgba(0, 0, 0, 0.082), 4.7px 4.7px 8.7px rgba(0, 0, 0, 0.095),
            7.4px 7.4px 13.8px rgba(0, 0, 0, 0.108), 12.1px 12.1px 22px rgba(0, 0, 0, 0.124),
            21.4px 21.4px 36.4px rgba(0, 0, 0, 0.144), 40px 40px 60px rgba(0, 0, 0, 0.19);
    }

    h2 {
        font-size: 30px;
        color: white;
        margin-top: 10px;
        text-shadow: 0px 0px 30px rgba(0, 0, 0, 0.3);
        text-align: center;
    }

    .shadow-down-right h1,
    .shadow-down-right h2 {
        text-shadow: 0.8px 0.8px 1.2px rgba(0, 0, 0, 0.046), 1.7px 1.7px 2.9px rgba(0, 0, 0, 0.066),
            2.9px 2.9px 5.3px rgba(0, 0, 0, 0.082), 4.7px 4.7px 8.7px rgba(0, 0, 0, 0.095),
            7.4px 7.4px 13.8px rgba(0, 0, 0, 0.108), 12.1px 12.1px 22px rgba(0, 0, 0, 0.124),
            21.4px 21.4px 36.4px rgba(0, 0, 0, 0.144), 40px 40px 60px rgba(0, 0, 0, 0.19);
    }
    .shadow-down-right-strong h1,
    .shadow-down-right-strong h2 {
        text-shadow: 0.8px 0.8px 1.2px rgba(0, 0, 0, 0.096), 1.7px 1.7px 2.9px rgba(0, 0, 0, 0.139),
            2.9px 2.9px 5.3px rgba(0, 0, 0, 0.172), 4.7px 4.7px 8.7px rgba(0, 0, 0, 0.2),
            7.4px 7.4px 13.8px rgba(0, 0, 0, 0.228), 12.1px 12.1px 22px rgba(0, 0, 0, 0.261),
            21.4px 21.4px 36.4px rgba(0, 0, 0, 0.304), 40px 40px 60px rgba(0, 0, 0, 0.4);
    }

    .shadow-right h1,
    .shadow-right h2 {
        text-shadow: 1.1px 0px 1.2px rgba(0, 0, 0, 0.046), 2.4px 0px 2.9px rgba(0, 0, 0, 0.066),
            4.1px 0px 5.3px rgba(0, 0, 0, 0.082), 6.6px 0px 8.7px rgba(0, 0, 0, 0.095),
            10.4px 0px 13.8px rgba(0, 0, 0, 0.108), 17px 0px 22px rgba(0, 0, 0, 0.124),
            29.9px 0px 36.4px rgba(0, 0, 0, 0.144), 56px 0px 60px rgba(0, 0, 0, 0.19);
    }

    @media (max-width: 800px) {
        h1 {
            font-size: 50px;
            margin-bottom: 5px;
        }

        h2 {
            font-size: 18px;
            margin-top: 5px;
        }
    }
</style>
